export default {
	URL: 'https://api-letsarapremiacao.infinitum-ti.com',
	API_URL: 'https://api-letsarapremiacao.infinitum-ti.com/api',
	API_DATALAKE_URL: 'https://api-homologacao.infinitum-ti.com/api',
	API_ETIQUETA_URL: 'https://api-letsaraetiquetas.infinitum-ti.com/api',
	OAPI_URL: 'https://api-letsarapremiacao.infinitum-ti.com/oapi',

	// URL: 'http://localhost:2403',
	// API_URL: 'http://localhost:2403/api',
	// API_DATALAKE_URL: 'http://localhost:3005/api',
	// API_ETIQUETA_URL: 'http://localhost:3011/api',
	// OAPI_URL: 'http://localhost:2403/oapi',
}
